import { jsx as _jsx } from "react/jsx-runtime";

function SvgCheckBox() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      d: "M19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2zm-9.211 14.767a1.106 1.106 0 01-1.567 0l-3.989-3.99A1.093 1.093 0 014.69 12a1.107 1.107 0 011.889-.778l3.2 3.19 7.644-7.645a1.108 1.108 0 011.567 1.566l-8.422 8.434z",
      fill: "currentColor"
    }, void 0)
  }), void 0);
}

export default SvgCheckBox;